var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAndroidButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 57,
    viewBox: "0 0 187 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.5C0 2.73858 2.23858 0.5 5 0.5H182C184.761 0.5 187 2.73858 187 5.5V51.5C187 54.2614 184.761 56.5 182 56.5H5C2.23858 56.5 0 54.2614 0 51.5V5.5Z",
    fill: "#0095CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3808 30.9518C91.1228 30.9518 88.4674 33.4564 88.4674 36.906C88.4674 40.3346 91.1228 42.8602 94.3808 42.8602C97.6401 42.8602 100.296 40.3346 100.296 36.906C100.294 33.4564 97.6387 30.9518 94.3808 30.9518ZM94.3808 40.5166C92.5953 40.5166 91.0563 39.0284 91.0563 36.9074C91.0563 34.764 92.5967 33.2982 94.3808 33.2982C96.1663 33.2982 97.7052 34.764 97.7052 36.9074C97.7052 39.027 96.1663 40.5166 94.3808 40.5166ZM81.4792 30.9518C78.2212 30.9518 75.5658 33.4564 75.5658 36.906C75.5658 40.3346 78.2212 42.8602 81.4792 42.8602C84.7385 42.8602 87.3939 40.3346 87.3939 36.906C87.3939 33.4564 84.7385 30.9518 81.4792 30.9518ZM81.4792 40.5166C79.6937 40.5166 78.1547 39.0284 78.1547 36.9074C78.1547 34.764 79.6951 33.2982 81.4792 33.2982C83.2647 33.2982 84.8036 34.764 84.8036 36.9074C84.805 39.027 83.2647 40.5166 81.4792 40.5166ZM66.1341 32.7802V35.3058H72.1153C71.9366 36.7268 71.4684 37.7642 70.7537 38.4852C69.8838 39.3644 68.5222 40.3346 66.1341 40.3346C62.4523 40.3346 59.5739 37.3344 59.5739 33.6132C59.5739 29.892 62.4523 26.8918 66.1341 26.8918C68.1205 26.8918 69.5707 27.6814 70.6415 28.6964L72.4048 26.9142C70.9088 25.4708 68.9239 24.3662 66.1341 24.3662C61.0906 24.3662 56.8506 28.5158 56.8506 33.6132C56.8506 38.7106 61.0906 42.8602 66.1341 42.8602C68.856 42.8602 70.9102 41.9572 72.5156 40.266C74.1668 38.5972 74.6807 36.2508 74.6807 34.3566C74.6807 33.7714 74.6364 33.2296 74.5463 32.7788H66.1341V32.7802ZM128.894 34.7416C128.404 33.4116 126.908 30.9518 123.851 30.9518C120.816 30.9518 118.293 33.3654 118.293 36.906C118.293 40.2436 120.794 42.8602 124.14 42.8602C126.84 42.8602 128.402 41.1914 129.051 40.2212L127.042 38.8674C126.373 39.86 125.457 40.5138 124.14 40.5138C122.824 40.5138 121.886 39.9048 121.284 38.7092L129.161 35.4164L128.894 34.7416ZM120.86 36.7268C120.793 34.4252 122.623 33.2534 123.941 33.2534C124.967 33.2534 125.837 33.7728 126.128 34.5162L120.86 36.7268ZM114.456 42.5004H117.044V24.999H114.456V42.5004ZM110.215 32.2832H110.126C109.546 31.5832 108.429 30.9518 107.025 30.9518C104.078 30.9518 101.379 33.5684 101.379 36.9298C101.379 40.2674 104.078 42.8616 107.025 42.8616C108.431 42.8616 109.546 42.2302 110.126 41.5092H110.215V42.366C110.215 44.6438 109.01 45.8618 107.069 45.8618C105.484 45.8618 104.502 44.7124 104.101 43.7422L101.847 44.69C102.494 46.2678 104.211 48.2082 107.069 48.2082C110.104 48.2082 112.671 46.4036 112.671 42.0048V31.3144H110.216V32.2832H110.215ZM107.248 40.5166C105.462 40.5166 103.968 39.0046 103.968 36.9298C103.968 34.8312 105.462 33.2982 107.248 33.2982C109.01 33.2982 110.394 34.8312 110.394 36.9298C110.394 39.0046 109.01 40.5166 107.248 40.5166ZM141.02 24.999H134.827V42.5004H137.41V35.87H141.019C143.883 35.87 146.701 33.7742 146.701 30.4352C146.701 27.0962 143.885 24.999 141.02 24.999ZM141.086 33.434H137.41V27.435H141.086C143.019 27.435 144.116 29.052 144.116 30.4352C144.116 31.7904 143.019 33.434 141.086 33.434ZM157.06 30.921C155.189 30.921 153.251 31.754 152.449 33.6006L154.743 34.568C155.233 33.6006 156.148 33.2842 157.105 33.2842C158.441 33.2842 159.8 34.0948 159.822 35.5354V35.716C159.354 35.4458 158.351 35.0412 157.127 35.0412C154.654 35.0412 152.136 36.4146 152.136 38.9808C152.136 41.323 154.164 42.8308 156.436 42.8308C158.173 42.8308 159.131 42.0426 159.732 41.1186H159.821V42.4696H162.317V35.7594C162.319 32.6542 160.022 30.921 157.06 30.921ZM156.747 40.5124C155.902 40.5124 154.721 40.084 154.721 39.0256C154.721 37.6746 156.192 37.1566 157.462 37.1566C158.597 37.1566 159.133 37.4044 159.822 37.7418C159.622 39.3644 158.241 40.5124 156.747 40.5124ZM171.407 31.3032L168.444 38.8912H168.355L165.28 31.3032H162.496L167.107 41.9082L164.478 47.8078H167.174L174.281 31.3032H171.407ZM148.127 42.5004H150.711V24.999H148.127V42.5004Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6828 14.84C65.6828 16.0132 65.3393 16.947 64.6508 17.6442C63.8696 18.473 62.8501 18.8874 61.5979 18.8874C60.3983 18.8874 59.3774 18.4674 58.5394 17.6274C57.7 16.786 57.2803 15.7444 57.2803 14.5012C57.2803 13.2566 57.7 12.215 58.5394 11.375C59.3774 10.5336 60.3983 10.1136 61.5979 10.1136C62.1935 10.1136 62.7628 10.2312 63.3031 10.465C63.8447 10.7002 64.2782 11.0124 64.6024 11.403L63.8724 12.1422C63.3224 11.4772 62.5648 11.1454 61.5965 11.1454C60.7211 11.1454 59.9648 11.4562 59.3262 12.0778C58.6876 12.6994 58.369 13.5072 58.369 14.4998C58.369 15.4924 58.6876 16.3002 59.3262 16.9218C59.9648 17.5434 60.7211 17.8542 61.5965 17.8542C62.5246 17.8542 63.2989 17.542 63.9181 16.9162C64.3198 16.5088 64.5525 15.9418 64.6148 15.2152H61.5965V14.2058H65.6232C65.6648 14.4256 65.6828 14.637 65.6828 14.84Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0686 11.3317H68.2843V13.9945H71.6974V15.0039H68.2843V17.6667H72.0686V18.6999H67.2163V10.2999H72.0686V11.3317Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5717 18.6999H75.5037V11.3317H73.1822V10.2999H78.8933V11.3317H76.5717V18.6999Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0252 18.6999V10.2999H84.0932V18.6999H83.0252Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8294 18.6999H87.7614V11.3317H85.4398V10.2999H91.151V11.3317H88.8294V18.6999Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.962 17.6148C101.145 18.4632 100.129 18.8874 98.9146 18.8874C97.6998 18.8874 96.6845 18.4632 95.8686 17.6148C95.0513 16.7664 94.6441 15.7276 94.6441 14.4998C94.6441 13.272 95.0513 12.2332 95.8686 11.3848C96.6845 10.5364 97.6998 10.1108 98.9146 10.1108C100.122 10.1108 101.136 10.5378 101.956 11.3904C102.777 12.243 103.187 13.279 103.187 14.4998C103.187 15.7276 102.778 16.7664 101.962 17.6148ZM96.6568 16.9106C97.2718 17.5406 98.0239 17.8542 98.9146 17.8542C99.8053 17.8542 100.559 17.5392 101.172 16.9106C101.787 16.2806 102.096 15.477 102.096 14.4998C102.096 13.5226 101.787 12.719 101.172 12.089C100.559 11.459 99.8053 11.1454 98.9146 11.1454C98.0239 11.1454 97.2718 11.4604 96.6568 12.089C96.0431 12.719 95.7342 13.5226 95.7342 14.4998C95.7342 15.477 96.0431 16.2806 96.6568 16.9106Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.685 18.6999V10.2999H105.985L110.024 16.8337H110.07L110.024 15.2153V10.2999H111.092V18.6999H109.977L105.751 11.8483H105.705L105.751 13.4667V18.6999H104.685Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6828 14.84C65.6828 16.0132 65.3393 16.947 64.6508 17.6442C63.8696 18.473 62.8501 18.8874 61.5979 18.8874C60.3983 18.8874 59.3774 18.4674 58.5394 17.6274C57.7 16.786 57.2803 15.7444 57.2803 14.5012C57.2803 13.2566 57.7 12.215 58.5394 11.375C59.3774 10.5336 60.3983 10.1136 61.5979 10.1136C62.1935 10.1136 62.7628 10.2312 63.3031 10.465C63.8447 10.7002 64.2782 11.0124 64.6024 11.403L63.8724 12.1422C63.3224 11.4772 62.5648 11.1454 61.5965 11.1454C60.7211 11.1454 59.9648 11.4562 59.3262 12.0778C58.6876 12.6994 58.369 13.5072 58.369 14.4998C58.369 15.4924 58.6876 16.3002 59.3262 16.9218C59.9648 17.5434 60.7211 17.8542 61.5965 17.8542C62.5246 17.8542 63.2989 17.542 63.9181 16.9162C64.3198 16.5088 64.5525 15.9418 64.6148 15.2152H61.5965V14.2058H65.6232C65.6648 14.4256 65.6828 14.637 65.6828 14.84Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0686 11.3317H68.2843V13.9945H71.6974V15.0039H68.2843V17.6667H72.0686V18.6999H67.2163V10.2999H72.0686V11.3317Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5717 18.6999H75.5037V11.3317H73.1822V10.2999H78.8933V11.3317H76.5717V18.6999Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0252 18.6999V10.2999H84.0932V18.6999H83.0252Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8294 18.6999H87.7614V11.3317H85.4398V10.2999H91.151V11.3317H88.8294V18.6999Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M101.962 17.6148C101.145 18.4632 100.129 18.8874 98.9146 18.8874C97.6998 18.8874 96.6845 18.4632 95.8686 17.6148C95.0513 16.7664 94.6441 15.7276 94.6441 14.4998C94.6441 13.272 95.0513 12.2332 95.8686 11.3848C96.6845 10.5364 97.6998 10.1108 98.9146 10.1108C100.122 10.1108 101.136 10.5378 101.956 11.3904C102.777 12.243 103.187 13.279 103.187 14.4998C103.187 15.7276 102.778 16.7664 101.962 17.6148ZM96.6568 16.9106C97.2718 17.5406 98.0239 17.8542 98.9146 17.8542C99.8053 17.8542 100.559 17.5392 101.172 16.9106C101.787 16.2806 102.096 15.477 102.096 14.4998C102.096 13.5226 101.787 12.719 101.172 12.089C100.559 11.459 99.8053 11.1454 98.9146 11.1454C98.0239 11.1454 97.2718 11.4604 96.6568 12.089C96.0431 12.719 95.7342 13.5226 95.7342 14.4998C95.7342 15.477 96.0431 16.2806 96.6568 16.9106Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M104.685 18.6999V10.2999H105.985L110.024 16.8337H110.07L110.024 15.2153V10.2999H111.092V18.6999H109.977L105.751 11.8483H105.705L105.751 13.4667V18.6999H104.685Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_11658_201891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4558 11.0529C14.0527 11.4841 13.8145 12.1533 13.8145 13.0199V43.9823C13.8145 44.8503 14.0527 45.5181 14.4558 45.9493L14.5583 46.0501L31.7194 28.7055V28.5011V28.2967L14.5583 10.9507L14.4558 11.0529Z",
    fill: "url(#paint0_linear_11658_201891)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4392 34.4889L31.7197 28.7055V28.5011V28.2967L37.4405 22.5146L37.5694 22.5888L44.3471 26.4809C46.2822 27.5925 46.2822 29.4111 44.3471 30.5241L37.5694 34.4161L37.4392 34.4889Z",
    fill: "url(#paint1_linear_11658_201891)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_11658_201891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5693 34.4146L31.7182 28.501L14.4561 45.9492C15.0932 46.6324 16.1474 46.7164 17.3345 46.036L37.5693 34.4146Z",
    fill: "url(#paint2_linear_11658_201891)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.5693 22.5876L17.3345 10.9676C16.1474 10.2858 15.0932 10.3712 14.4561 11.0544L31.7196 28.5026L37.5693 22.5876Z",
    fill: "url(#paint3_linear_11658_201891)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5 1.5H182V-0.5H5V1.5ZM186 5.5V51.5H188V5.5H186ZM182 55.5H5V57.5H182V55.5ZM1 51.5V5.5H-1V51.5H1ZM5 55.5C2.79086 55.5 1 53.7091 1 51.5H-1C-1 54.8137 1.6863 57.5 5 57.5V55.5ZM186 51.5C186 53.7091 184.209 55.5 182 55.5V57.5C185.314 57.5 188 54.8137 188 51.5H186ZM182 1.5C184.209 1.5 186 3.29086 186 5.5H188C188 2.18629 185.314 -0.5 182 -0.5V1.5ZM5 -0.5C1.68629 -0.5 -1 2.18629 -1 5.5H1C1 3.29086 2.79086 1.5 5 1.5V-0.5Z",
    fill: "#A6A6A6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_11658_201891",
    x: 13.8145,
    y: 10.4971,
    width: 31.9844,
    height: 36.0088,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11658_201891"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_11658_201891",
    result: "effect2_innerShadow_11658_201891"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_11658_201891",
    x: 14.4561,
    y: 28.501,
    width: 23.1133,
    height: 18.0049,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11658_201891"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11658_201891",
    x1: 30.1981,
    y1: 12.6923,
    x2: 6.70468,
    y2: 35.9371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11658_201891",
    x1: 46.866,
    y1: 28.5011,
    x2: 13.3502,
    y2: 28.5011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11658_201891",
    x1: 34.3918,
    y1: 31.7124,
    x2: 2.53168,
    y2: 63.2354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11658_201891",
    x1: 10.1085,
    y1: 0.747298,
    x2: 24.3349,
    y2: 14.8232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidButton);
export default __webpack_public_path__ + "static/media/android-button.90bcbe45.svg";
export { ForwardRef as ReactComponent };